export const ONLINE_PROFESSION_FLAG = "enable-online-profession";

/**
 * Whether the online profession features (the "Online országosan elérhető
 * vagyok" line, the online coverage banners, etc.) are enabled.
 *
 * The experiment has three groups:
 * - `control`: features off
 * - `variant1`: features on, but the "Személyes konzultáció: {city}" line hidden
 * - `variant2`: features on, with the "Személyes konzultáció: {city}" line shown
 *
 * Both `variant1` and `variant2` enable the online profession features.
 *
 * @param {{ isVariant: (name: string, variant: string) => boolean }} ab the injected $ab plugin
 * @returns {boolean}
 */
export function isOnlineProfessionEnabled(ab) {
  return (
    ab.isVariant(ONLINE_PROFESSION_FLAG, "variant1") ||
    ab.isVariant(ONLINE_PROFESSION_FLAG, "variant2")
  );
}

/**
 * Whether the "Személyes konzultáció: {city}" line should be visible on the
 * person cards. Only shown in `variant2`; in `variant1` everything else stays
 * the same but this line is hidden.
 *
 * @param {{ isVariant: (name: string, variant: string) => boolean }} ab the injected $ab plugin
 * @returns {boolean}
 */
export function isInPersonConsultationVisible(ab) {
  return ab.isVariant(ONLINE_PROFESSION_FLAG, "variant2");
}
